module.exports = __webpack_public_path__ + "img/afrika_nap_program-02.a68734a8.jpg";